/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
  AsyncResult,
  callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
} from "@msdyn365-commerce/retail-proxy";
// @ts-ignore
import * as EntityClasses from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g";
import * as DataServiceEntities from "./DataServiceEntities.g";

function getShiptrackTrackingNumberQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getShiptrackTrackingNumberInput(
  salesOrderNum: string
): IDataServiceRequest {
  const query = getShiptrackTrackingNumberQuery();
  return query.createDataServiceRequestForOperation(
    "GetShiptrackTrackingNumber",
    true,
    DataServiceEntities.ShipmentTrackingLinesExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.IShipmentTrackingLines",
    },
    {
      salesOrderNum: salesOrderNum,
    }
  );
}

export function getShiptrackTrackingNumberAsync(
  context: IContext,
  salesOrderNum: string
): AsyncResult<DataServiceEntities.IShipmentTrackingLines> {
  const request = getShiptrackTrackingNumberInput(salesOrderNum);
  return callActionOrExecute<DataServiceEntities.IShipmentTrackingLines>(
    request,
    context.callerContext
  );
}
